"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BadgeCount = exports.TabLabel = exports.TabContainerDiv = exports.TabContainerNav = void 0;
var react_router_dom_1 = require("react-router-dom");
var styled_components_1 = __importStar(require("styled-components"));
var styles_1 = require("../../Typography/Paragraphs/styles");
var tabContainerStyles = (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 8px 16px;\n  cursor: pointer;\n  position: relative;\n\n  text-decoration: none;\n\n  &:after {\n    content: '';\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    height: 1px;\n    background-color: transparent;\n    transition: background-color 0.3s;\n    z-index: 1;\n  }\n\n  span {\n    color: ", ";\n  }\n  &.active {\n    span {\n      color: ", ";\n    }\n\n    p {\n      background-color: ", ";\n    }\n\n    &:after {\n      background-color: ", ";\n    }\n  }\n"], ["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 8px 16px;\n  cursor: pointer;\n  position: relative;\n\n  text-decoration: none;\n\n  &:after {\n    content: '';\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    height: 1px;\n    background-color: transparent;\n    transition: background-color 0.3s;\n    z-index: 1;\n  }\n\n  span {\n    color: ", ";\n  }\n  &.active {\n    span {\n      color: ", ";\n    }\n\n    p {\n      background-color: ", ";\n    }\n\n    &:after {\n      background-color: ", ";\n    }\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.text.neuGray600;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.bg.primary;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.bg.primary;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.bg.primary;
});
exports.TabContainerNav = (0, styled_components_1.default)(react_router_dom_1.NavLink)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), tabContainerStyles);
exports.TabContainerDiv = styled_components_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), tabContainerStyles);
exports.TabLabel = styled_components_1.default.span(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), (0, styles_1.bodyStyle)({ size: 'md', bold: true }));
exports.BadgeCount = styled_components_1.default.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  margin-left: 5px;\n"], ["\n  margin-left: 5px;\n"])));
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;
